import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

export default new Router({
  routes: [{
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    name: 'PageView',
    component: resolve => require(['@/view/PageView'], resolve),
    children: [{
        path: '/',
        redirect: '/home'
      }, {
        path: '/home',
        name: 'home',
        component: resolve => require(['@/view/HomePage'], resolve),
        meta: {
          title: '首页'
        }
      }, {
        path: '/project_CharterShip',
        name: 'CharterShip',
        component: resolve => require(['@/view/Project_CharterShip'], resolve),
        meta: {
          title: '项目丨包船'
        }
      }, {
        path: '/CharterShip_info',
        name: 'CharterShip_info',
        component: resolve => require(['@/view/Project_CharterShip_info'], resolve),
        meta: {
          title: '包船'
        }
      },
      {
        path: '/project_CharterPlane',
        name: 'CharterPlane',
        component: resolve => require(['@/view/Project_CharterPlane'], resolve),
        meta: {
          title: '项目丨空运包机'
        }
      },
      {
        path: '/project_Russia',
        name: 'RussiaProject',
        component: resolve => require(['@/view/Project_Russia'], resolve),
        meta: {
          title: '项目丨俄罗斯多式联运'
        }
      },
      {
        path: '/CharterPlane_info',
        name: 'CharterPlane_info',
        component: resolve => require(['@/view/Project_CharterPlane_info'], resolve),
        meta: {
          title: '空运包机'
        }
      },
      {
        path: '/Project_ElectronicCigarette',
        name: 'ElectronicCigarette',
        component: resolve => require(['@/view/Project_ElectronicCigarette'], resolve),
        meta: {
          title: '项目丨电子烟'
        }
      },
      {
        path: '/Projct_Engineering',
        name: 'Engineering',
        component: resolve => require(['@/view/Projct_Engineering'], resolve),
        meta: {
          title: '项目丨工程项目物流'
        }
      },
      {
        path: '/Projct_semiconductor',
        name: '2',
        component: resolve => require(['@/view/Projct_semiconductor'], resolve),
        meta: {
          title: '项目丨半导体全球物流供应链'
        }
      },
      {
        path: '/Projct_Personalbelongings',
        name: '2',
        component: resolve => require(['@/view/Projct_Personalbelongings'], resolve),
        meta: {
          title: '项目丨私人物品'
        }
      },
      {
        path: '/service_BondedPage',
        name: 'Bonded',
        component: resolve => require(['@/view/Service_BondedPage'], resolve),
        meta: {
          title: '服务丨保税物流服务'
        }
      },
      {
        path: '/service_Plane',
        name: 'Plane',
        component: resolve => require(['@/view/Service_Plane'], resolve),
        meta: {
          title: '服务丨内、国外海陆空 运输代理服务'
        }
      },
      {
        path: '/service_Warehouse',
        name: 'Warehouse',
        component: resolve => require(['@/view/Service_Warehouse'], resolve),
        meta: {
          title: '服务丨仓库服务'
        }
      },
      {
        path: '/service_Supply',
        name: 'Supply',
        component: resolve => require(['@/view/Service_Supply'], resolve),
        meta: {
          title: '服务丨供应链服务'
        }
      },
      {
        path: '/service_CrossBorder',
        name: 'CrossBorder',
        component: resolve => require(['@/view/Service_CrossBorder'], resolve),
        meta: {
          title: '服务丨国内跨境运输'
        }
      },
      {
        path: '/project_Childpage',
        name: 'Childpage',
        component: resolve => require(['@/view/project_Childpage'], resolve),
        meta: {
          title: '项目'
        }
      },
      {
        path: '/newsPage',
        name: 'newsPage',
        component: resolve => require(['@/view/NewsPage'], resolve),
        meta: {
          title: '新闻动态'
        }
      },
      {
        path: '/newsPage_info',
        name: 'newsPage_info',
        component: resolve => require(['@/view/newsPage_info'], resolve),
        meta: {
          title: '动态'
        }
      },
      {
        path: '/newsinformation',
        name: 'newsinformation',
        component: resolve => require(['@/view/NewsInformation'], resolve),
        meta: {
          title: '新闻动态'
        }
      }, {
        path: '/companyintroduction',
        name: 'companyintroduction',
        component: resolve => require(['@/view/CompanyIntroduction'], resolve),
        meta: {
          title: '关于我们'
        }
      }, {
        path: '/joinUs',
        name: 'joinUs',
        component: resolve => require(['@/view/JoinUs'], resolve),
        meta: {
          title: '加入我们'
        }
      },
      {
        path: '/jobchance',
        name: 'jobchance',
        component: resolve => require(['@/view/JobChance'], resolve),
        meta: {
          title: '工作机会'
        }
      }, {
        path: '/contactus',
        name: 'contactus',
        component: resolve => require(['@/view/ContactUs'], resolve),
        meta: {
          title: '联系我们'
        }
      },
      {
        path: '/servicedetail',
        name: 'servicedetail',
        component: resolve => require(['@/view/ServiceDetail'], resolve),
        meta: {
          title: '相关服务'
        }
      }
    ]
  }]
})
